import { useNavigate } from "react-router-dom";
import {
  getLocal,
  NFeCadastroTransporteDto,
  NFeDto,
  STORAGENFE_KEY,
  updateLocal,
} from "../../NFe.Dto";
import { useFieldArray, useForm } from "react-hook-form";
import { VolumesSchema } from "./NFe.Cadastro.Volumes.Dto";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FloatInput, FloatNumericInput } from "src/componentes";

const NFeCadastroVolumesView = () => {
  const navigate = useNavigate();
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const transporte = nf?.transporte;

  const handleVoltar = () => () => {
    navigate("../transporte");
  };

  const form = useForm<NFeCadastroTransporteDto>({
    resolver: yupResolver(VolumesSchema),
    defaultValues: {
      ...transporte,
      volume: transporte?.volume ?? [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "volume",
  });

  const onSubmit = (data: NFeCadastroTransporteDto) => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      transporte: data,
    });

    navigate("../informacoesadicionais");
  };

  return (
    <>
      <Form noValidate onSubmit={form.handleSubmit(onSubmit)}>
        <div className="mt-3 mb-5">
          {fields.map((field, index) => (
            <Row key={field.id} className="border rounded p-3 mb-3">
              <Col xs={12} className="mb-2 d-flex justify-content-between">
                <strong>Volume {index + 1}</strong>

                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => remove(index)}
                >
                  Remover
                </Button>
              </Col>

              <Col xs={12} md={4} className="mb-3">
                <FloatInput
                  label="Quantidade"
                  inputMask="int"
                  registerField={form.register(
                    `volume.${index}.quantidadeVolumes`
                  )}
                  errorsMessage={
                    form.formState.errors.volume?.[index]?.quantidadeVolumes
                  }
                />
              </Col>

              <Col xs={12} md={4} className="mb-3">
                <FloatInput
                  label="Espécie"
                  inputMask="maiusculas"
                  registerField={form.register(`volume.${index}.especie`)}
                  errorsMessage={form.formState.errors.volume?.[index]?.especie}
                />
              </Col>

              <Col xs={12} md={4} className="mb-3">
                <FloatInput
                  label="Marca"
                  inputMask="maiusculas"
                  registerField={form.register(`volume.${index}.marca`)}
                  errorsMessage={form.formState.errors.volume?.[index]?.marca}
                />
              </Col>

              <Col xs={12} md={4} className="mb-3">
                <FloatNumericInput
                  label="Peso Líquido"
                  control={form.control}
                  name={`volume.${index}.pesoLiquido`}
                  errorsMessage={
                    form.formState.errors.volume?.[index]?.pesoLiquido
                  }
                />
              </Col>

              <Col xs={12} md={4} className="mb-3">
                <FloatNumericInput
                  label="Peso Bruto"
                  control={form.control}
                  name={`volume.${index}.pesoBruto`}
                  errorsMessage={
                    form.formState.errors.volume?.[index]?.pesoBruto
                  }
                />
              </Col>
            </Row>
          ))}

          <div className="d-grid mt-3">
            <Button
              variant="outline-primary"
              onClick={() =>
                append({
                  quantidadeVolumes: 1,
                  especie: "",
                  marca: "",
                  pesoLiquido: 0,
                  pesoBruto: 0,
                })
              }
            >
              + Adicionar Volume
            </Button>
          </div>
        </div>

        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar()}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </>
  );
};
export default NFeCadastroVolumesView;
